/* One-tap upsell add. Reuses the drawer's section re-render flow; the snippet
   re-renders after each add, so a purchased upsell disappears from the list. */

/* One-time offer wrapper: hides itself for the session when dismissed.
   Re-renders re-create the element, so the check runs on every cart change. */
if (!customElements.get('mov-cart-offer')) {
  customElements.define(
    'mov-cart-offer',
    class MovCartOffer extends HTMLElement {
      static DISMISS_KEY = 'mov-cart-offer-dismissed';

      connectedCallback() {
        try {
          if (sessionStorage.getItem(MovCartOffer.DISMISS_KEY) === 'true') {
            this.hidden = true;
            return;
          }
        } catch {
          /* storage unavailable — offer simply stays visible */
        }
        const dismiss = this.querySelector('[data-offer-dismiss]');
        if (dismiss) {
          dismiss.addEventListener('click', () => {
            try {
              sessionStorage.setItem(MovCartOffer.DISMISS_KEY, 'true');
            } catch {
              /* ignore */
            }
            this.hidden = true;
          });
        }
      }
    }
  );
}

if (!customElements.get('mov-cart-upsell')) {
  customElements.define(
    'mov-cart-upsell',
    class MovCartUpsell extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (this.button) this.button.addEventListener('click', () => this.add());
      }

      add() {
        this.button.disabled = true;
        this.button.classList.add('is-loading');
        fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(this.dataset.variant), quantity: 1 }],
            sections: ['cart-drawer', 'cart-icon-bubble'],
          }),
        })
          .then((response) => response.json())
          .then((state) => {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mov-cart-upsell', cartData: state });
            }
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
              drawer.renderContents(state);
            }
          })
          .finally(() => {
            this.button.disabled = false;
            this.button.classList.remove('is-loading');
          });
      }
    }
  );
}
